import {useEffect,useState,useRef} from 'react';
import { useNavigate,useParams } from "react-router-dom";

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircleIcon from '@mui/icons-material/Circle';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';

import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import Alert from '@mui/material/Alert';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import { convertToRaw,convertFromRaw, EditorState } from "draft-js";
//import { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { Fragment } from "react";

import parse from 'html-react-parser';

 import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import AppLogout from '../components/AppLogout.jsx'

//services
import AuthService from '../service/auth'
import ProjectService from '../service/Project'
import ClientService from '../service/Client'
import ClientLogService from '../service/ClientLog'
import ExportsService from '../service/Exports'
import ReportsService from '../service/Reports'
import UtilsService from '../service/Utils'


const NotesEditorToolbar ={
  
  //options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
  options: [ 'inline','fontSize','fontFamily','colorPicker'],
  inline:{  options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript']},
  colorPicker:{ },
  /*inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
    bold: { icon: bold, className: undefined },
    italic: { icon: italic, className: undefined },
    underline: { icon: underline, className: undefined },
    strikethrough: { icon: strikethrough, className: undefined },
    monospace: { icon: monospace, className: undefined },
    superscript: { icon: superscript, className: undefined },
    subscript: { icon: subscript, className: undefined },
  },
  blockType: {
    inDropdown: true,
    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  fontSize: {
    icon: fontSize,
    options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
 / fontFamily: {
    options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  list: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['unordered', 'ordered', 'indent', 'outdent'],
    unordered: { icon: unordered, className: undefined },
    ordered: { icon: ordered, className: undefined },
    indent: { icon: indent, className: undefined },
    outdent: { icon: outdent, className: undefined },
  },
  textAlign: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['left', 'center', 'right', 'justify'],
    left: { icon: left, className: undefined },
    center: { icon: center, className: undefined },
    right: { icon: right, className: undefined },
    justify: { icon: justify, className: undefined },
  },
  colorPicker: {
    icon: color,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
      'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
      'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
      'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
      'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
      'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
  },
  link: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    dropdownClassName: undefined,
    showOpenOptionOnHover: true,
    defaultTargetOption: '_self',
    options: ['link', 'unlink'],
    link: { icon: link, className: undefined },
    unlink: { icon: unlink, className: undefined },
    linkCallback: undefined
  },
  emoji: {
    icon: emoji,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    emojis: [
      '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
      '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
      '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
      '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
      '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
      '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
      '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
      '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
      '✅', '❎', '💯',
    ],
  },
  embedded: {
    icon: embedded,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    embedCallback: undefined,
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
  image: {
    icon: image,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    urlEnabled: true,
    uploadEnabled: true,
    alignmentEnabled: true,
    uploadCallback: undefined,
    previewImage: false,
    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
    alt: { present: false, mandatory: false },
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
  remove: { icon: eraser, className: undefined, component: undefined },
  history: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['undo', 'redo'],
    undo: { icon: undo, className: undefined },
    redo: { icon: redo, className: undefined },
  },*/

}

const nutrientTypes = [
	"energy_kcal",
	"energy_kJ",
	"protein_g",
	"carbohydrate_g",
	"total_sugars_g",
	"aoac_fibre_g",
	"fat_g",
	"satd_fa__100g_fd_g",
	"mono_fa__100g_food_g",
	"poly_fa__100g_food_g",
	"n_6_poly__100g_food_g",
	"n_3_poly__100g_food_g",
	"trans_fas__100g_food_g",
	"cholesterol_mg",
	"total_vitamin_a_µg",
	"retinol_µg",
	"carotene_µg",
	"vitamin_d_µg",
	"vitamin_e_mg",
	"vitamin_k_µg",
	"thiamin_mg",
	"riboflavin_mg",
	"niacin_mg",
	"tryptophan_60_mg",
	"niacin_equivalent_mg",
	"vitamin_b6_mg",
	"vitamin_b12_µg",
	"total_folate_µg",
	"natural_folate_µg",
	"folic_acid_µg",
	"dietary_folate_equivalents_µg",
	"pantothenate_mg",
	"biotin_µg",
	"vitamin_c_mg",
	"sodium_mg",
	"potassium_mg",
	"calcium_mg",
	"magnesium_mg",
	"phosphorus_mg",
	"iron_mg",
	"copper_mg",
	"zinc_mg",
	"selenium_µg",
	"iodine_µg"
]

const formatDate=function(d){

	return UtilsService.formatDate(d);
}

const ClientLogs = () => {
	
	const navigate = useNavigate();
	//protected page check if logged in
	const [currentUser,setCurrentUser]=useState({});
	const [projectData,setProjectData]=useState([]);
	const [projectFound,setProjectFound]=useState(false);
	
	const [clientData,setClientData]=useState([]);
	const [clientLoaded,setClientLoaded]=useState(false);
	const [clientLogData,setClientLogData]=useState([]);

	const [numberOfFoodGroups, setNumberOfFoodGroups] = useState("");
	const [nutrientTypeTopContributors, setNutrientTypeTopContributors] = useState("");
	const [nutrientTypePie, setNutrientTypePie] = useState("");
	const [nutrientTypeBar, setNutrientTypeBar] = useState("");
		
	let params = useParams();
	let client_id =params.client_id;
	console.log('client_id',client_id);
	let project_id =ProjectService.getCurrentProject();//params.id;
	console.log('project_id',project_id);
	let showNew =params.show_new;
	console.log('showNew',showNew);
		
	useEffect(() => {
		if(!AuthService.isUserLoggedIn()){
			// not logged in navigate back to login
			navigate("/login");
		}else{
				setCurrentUser(AuthService.getCurrentUser());
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				console.log(AuthService.getCurrentUser());
				var currentUser=AuthService.getCurrentUser();
				//expired Account
				if(currentUser.expired){
					var string = "account_type="+AuthService.getCurrentUser().__t+"&type=expired";
					console.log('string',string);
					var encodedString = btoa(string); // Base64 encode the String
					console.log('encodedString',encodedString);
					navigate("/restricted/"+encodedString);
					
				}else{//unverified account
					if(!currentUser.email_verified){
						var string = "account_type="+AuthService.getCurrentUser().__t+"&type=emaiverification";
						console.log('string',string);
						var encodedString = btoa(string); // Base64 encode the String
						console.log('encodedString',encodedString);
						navigate("/restricted/"+encodedString);
						
					}else{////force change Password
						if(currentUser.force_password_change){
							//not implemented	
						
						}else{
							//load project if set 
							if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
								loadProjectById(project_id);
							}
							if((typeof client_id !=="undefined")&&(client_id!==null)){
								console.log('not null or undefined client_id',client_id);
								loadClientById(client_id);
								loadClientLogById(client_id);
							}
							if(typeof showNew !=="undefined"){
								if(showNew=='true'){
									setNewClientLogModalOpen(true);
								}
							}
							//load
							if(account_type=='Admin'){//Admin
						
							}else if(account_type=='Master'){//Master
							
								
							}else if(account_type=='Researcher'){//Researcher
								
							}
						}
					}
				}	
		}
	}, []);
	
		
	//load project
	function loadProjectById(project_id){
		ProjectService.getById(project_id).then(function(res){
		setProjectData(res.data);
		console.log(res.data);
		setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			setProjectFound(false);
		});
	}
	
	//Client Log
	const [openNewClientLogModal, setNewClientLogModalOpen] = useState(false);
	const handleNewClientLogModalOpen = () => {
		setNewClientLogModalOpen(true);
	};

	//Change file type text dynamically in download dialog
	const [reportType, setReportType] = useState("");

	//Open/Close Report Download in Progress Dialog
	const [openDownloadModal, setDownloadModal] = useState(false);

	//Download report on download button click and close the modal.
	const handleDownloadModalClose = () => {
		setDownloadDisabled(true);
		setDownloadModal(false);
		window.open(reportUrl,"_blank");
	};

	const [openReportConfigModal, setOpenReportConfigModal] = useState(false);

	//Download report on download button click and close the modal.
	const handleReportConfigModalClose = () => {
		setOpenReportConfigModal(false);
		setDownloadModal(true);
		handleConfigureReport();
	};

	//Enable/disable Download button 
	const [downloadDisabled, setDownloadDisabled] = useState(true);

	
	//date
	const [dateOfLog, setDateOfLog] = useState('');
	const handleDateOfLogChange = (event) => {
		console.log(event.$d);
		setDateOfLog(event.$d);
		const tempDate = new Date(event.$d);
		let day_index = tempDate.getDay();
		setDayOfWeek(daysOfWeek[day_index]);
	};
	
	//day of week
	const [daysOfWeek, setDaysOfWeek] = useState(["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]);
	const [dayOfWeek, setDayOfWeek] = useState('');
	const handleDayOfWeekChange = (event) => {
		console.log(event.target.value);
		setDayOfWeek(event.target.value);
	};
	
	//Work / School day
	const [workSchoolDay, setWorkSchoolDay] = useState(null);
	const handleWorkSchoolDayChange = (event) => {
		console.log(event.target.value);
		setWorkSchoolDay(event.target.value);
	};
	
	const handleNewClientLogModalClose = () => {
		setDateOfLog('');
		setDayOfWeek('');
		setWorkSchoolDay(null);
		setNewClientLogModalOpen(false);
		setErrorStatus(false);
		setErrorMessage("");
		setSuccessStatus(false);
		setSuccessMessage("");
	};
	
	//Notes
	const [tempData,setTempData]=useState(null);
	
	const tempContent ={"blocks":[{"key":"6vocr","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}};
		
	const [editorState, setEditorState] = useState(EditorState.createWithContent(convertFromRaw(tempContent)));
	  const onEditorStateChange = function (editorState) {
		setEditorState(editorState);
		const content = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
		console.log(content);
		setTempData(convertToRaw(editorState.getCurrentContent()));
	};

	// //New report created
	// const handleDownloadReport = () => {
	// 	setDownloadDisabled(true);
	// 	setDownloadModal(false);
	// 	window.open(reportUrl,"_blank");
	// }

	//new client log
	const handleSubmitNewClientLog=(event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		
		//clear error messages
		setErrorStatus(false);
		setErrorMessage("");
		setSuccessStatus(false);
		setSuccessMessage("");
		

		var _tempClientLog={'client':client_id,'completed':false,'created_by':AuthService.getCurrentUser()._id};
		//form data 
		const data = new FormData(event.currentTarget);
		if(data.get('work_school_day')!==''){
			_tempClientLog.work_school_day =data.get('work_school_day');
		}else{
			_tempClientLog.work_school_day =null;
		}

		
		//other data
		_tempClientLog.date =dateOfLog;
		_tempClientLog.day_of_week =dayOfWeek;
		
		if(tempData !== null) {
			console.log(JSON.stringify(tempData));
			_tempClientLog.notes=JSON.stringify(tempData);
		}else{
			_tempClientLog.notes=JSON.stringify(tempContent);
		}
		console.log('_tempClientLog',_tempClientLog);
		
		if(_tempClientLog.date!==''){
			
			ClientLogService.create(_tempClientLog).then(function(res){
				console.log(res.data);
				var _newClientLog= res.data;
				navigate("/client/log/"+_newClientLog._id);
			}).catch(function(error){
				console.log(error);
				setErrorStatus(true);
				setErrorMessage("Error: "+error);
			});
			
		}else{
			setErrorStatus(true);
			setErrorMessage("please select a date");
		}

	};
	
	const [ShowErrorMessage,setErrorStatus]=useState(false); 
	const [ErrorText,setErrorMessage]=useState(""); 
	
	const [ShowSuccessMessage,setSuccessStatus]=useState(false); 
	const [SuccessText,setSuccessMessage]=useState("");
	
	function loadClientById(client_id){
			ClientService.getById(client_id).then(function(res){
				setClientData(res.data);
				setClientLoaded(true);
				console.log(res.data);
				var _client= res.data;

				console.log('_client',_client);
			}).catch(function(error){
					console.log(error);
			});
	}
		/* client logs */		
		function loadClientLogById(client_id){
				ClientLogService.getByFilter({'client':client_id}).then(function(res){
					var _unsortedLog=res.data;
					var sortedLog = _unsortedLog.sort(function(a,b){
						return new Date(b.created_date) - new Date(a.created_date);
					});
					setClientLogData(sortedLog);
					console.log(res.data);
				}).catch(function(error){
					console.log(error);
				});
		}
		
	/* Download logs as csv file*/
	const [downloadUrl,setDownloadUrl]=useState("");
	const stateRef = useRef();
	stateRef.loaded = false;
	
	const handleTestDownload = (e) => {
		var _table ='client_log';
		var _filter={'_id':client_id};

		console.log('_filter',_filter);
		ExportsService.build(_table,_filter).then(function(res){
			setReportType("CSV");
			console.log(res.data);
			var filename =res.data.filename;
			var url=ExportsService.getUrl(filename);
			console.log('url',url);
			setDownloadUrl(url);
			
			var counter=0;
			var refreshIntervalId = setInterval(function(){
				checkIfBuilt(filename);
				if(stateRef.loaded){
					clearInterval(refreshIntervalId);
					window.open(url,'_blank');
				}
				if(counter==20){
					clearInterval(refreshIntervalId);
					toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
				}
				counter++;
			}, 1000);
						
		}).catch(function(error){
				console.log(error);
				toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
		});
	  };
	  
	const handleClientLogDownload = (e) => {
		var _table ='client_log';
		var _filter={'_id':client_id};

		console.log('_filter',_filter);
		ExportsService.build(_table,_filter).then(function(res){
			setReportType("CSV");
			console.log(res.data);
			var filename =res.data.filename;
			var url=ExportsService.getUrl(filename);
			console.log('url',url);
			setDownloadUrl(url);
			
			var counter=0;
			var refreshIntervalId = setInterval(function(){
				checkIfBuilt(filename);
				if(stateRef.loaded){
					clearInterval(refreshIntervalId);
					window.open(url,'_blank');
				}
				if(counter==20){
					clearInterval(refreshIntervalId);
					toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
				}
				counter++;
			}, 1000);
						
		}).catch(function(error){
				console.log(error);
				toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
		});
	  };
	  
	const handleClientLogDailyTotalsDownload = (e) => {
		var _table ='client_log_daily_totals';
		var _filter={'_id':client_id};

		console.log('_filter',_filter);
		ExportsService.build(_table,_filter).then(function(res){
			setReportType("CSV");
			console.log(res.data);
			var filename =res.data.filename;
			var url=ExportsService.getUrl(filename);
			console.log('url',url);
			setDownloadUrl(url);
			
			var counter=0;
			var refreshIntervalId = setInterval(function(){
				checkIfBuilt(filename);
				if(stateRef.loaded){
					clearInterval(refreshIntervalId);
					window.open(url,'_blank');
				}
				if(counter==20){
					clearInterval(refreshIntervalId);
					toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
				}
				counter++;
			}, 1000);
						
		}).catch(function(error){
				console.log(error);
				toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
		});
	};
	  
	const handleClientLogDailyAveragesDownload = (e) => {
		var _table ='client_log_daily_averages';
		var _filter={'_id':client_id};

		console.log('_filter',_filter);
		ExportsService.build(_table,_filter).then(function(res){
			setReportType("CSV");
			console.log(res.data);
			var filename =res.data.filename;
			var url=ExportsService.getUrl(filename);
			console.log('url',url);
			setDownloadUrl(url);
			
			var counter=0;
			var refreshIntervalId = setInterval(function(){
				checkIfBuilt(filename);
				if(stateRef.loaded){
					clearInterval(refreshIntervalId);
					window.open(url,'_blank');
				}
				if(counter==20){
					clearInterval(refreshIntervalId);
					toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

					});
				}
				counter++;
			}, 1000);
						
		}).catch(function(error){
				console.log(error);
				toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
		});
	  };
	  
	  function checkIfBuilt(filename){
		  	ExportsService.exists(filename).then(function(res){
			if(res.data.exists){
				stateRef.loaded=true;
			}
		}).catch(function(error){
				console.log(error);
		});
	  }
	  
	/* generate report*/
	const [reportUrl,setReportUrl]=useState("");
	//const stateRef = useRef();
	stateRef.report_loaded = false;
	
	const handleGenerateReport = (e) => {
		setOpenReportConfigModal(true);
	};

	// useEffect(() => {
	// 	console.log(numberOfFoodGroups);
	// 	console.log(nutrientTypeBar);
	// 	console.log(nutrientTypePie);
	// }, [numberOfFoodGroups, nutrientTypeBar, nutrientTypePie]);

	const handleConfigureReport = (e) => {
		var _opt={'type':'feedback','client_id':client_id, 
			'config[0]': numberOfFoodGroups, 
			'config[1]': nutrientTypeTopContributors, 
			'config[2]': nutrientTypePie, 
			'config[3]': nutrientTypeBar};//no nested objects

		ReportsService.generateReport(_opt).then(function(res){
			setReportType("PDF");
			setDownloadModal(true);
			console.log(res.data);
			var filename =res.data.uniqueID+'.pdf';
			var url=ReportsService.getUrl(filename);
			console.log('url',url);
			setReportUrl(url);

			var counter=0;
			var refreshIntervalId = setInterval(function(){
				checkIfGenerated(filename);
				if(stateRef.report_loaded){
					clearInterval(refreshIntervalId);
					setDownloadDisabled(false);
				}
				if(counter==20){
					clearInterval(refreshIntervalId);
				}
				counter++;
			}, 1000);
						
		}).catch(function(error){
				console.log(error);
		});
	};
	  
	  function checkIfGenerated(filename){
		  	ReportsService.exists(filename).then(function(res){
				console.log('res.data',res.data);
			if(res.data.exists){
				stateRef.report_loaded=true;
			}
		}).catch(function(error){
				console.log(error);
		});
	  }
	
	
		  	//https://fkhadra.github.io/react-toastify/introduction/
	const notify = () => toast.success("Success Notification !", {
        position:"top-right",
		autoClose:1000,
		hideProgressBar:true,
		theme:"colored",
     });
	 
	 
  return(
  <>
	<TopPrivateNavigation/>
	<AppLogout>
	 <ToastContainer  />
		{/* error no project found */}
	{(!projectFound) ?
		<>
		
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
		 <Typography color="text.primary">ClientLogs</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		<br/>
		
		
		</>
	:<></>}
	{/* if project is found */}
	{(projectFound) ?
	<>
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/projects"
        >
          Projects
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/project/${projectData._id}`}
        >
          {projectData.name}
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/client/view/${clientData._id}`}
        >
          {clientData.code}
        </Link>
		 <Typography color="text.primary">Logs</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		<br/>
	
	</>
	:<></>}
	
	<Button  variant="contained" endIcon={<AddIcon />}  onClick={handleNewClientLogModalOpen}>
		Create New Log  
	</Button>
		
	{/* manage client log dialog */}
    <Dialog open={openNewClientLogModal} >
		<Box component="form" onSubmit={handleSubmitNewClientLog} noValidate sx={{ mt: 1 }}>
        <DialogTitle>New Client Log</DialogTitle>
        <DialogContent>
          <DialogContentText>
			{ ShowErrorMessage &&
				<Alert severity="error">{ErrorText}</Alert>
			} 
			{ ShowSuccessMessage &&
				<Alert severity="success">{SuccessText}</Alert>
			}
          </DialogContentText>
		  <br/>
			
			<LocalizationProvider dateAdapter={AdapterDayjs}>
			  <DemoContainer   components={['DatePicker']}>
				<DatePicker sx={{width:'500px'}} disableFuture value={dayjs(dateOfLog)} format="DD-MM-YYYY"  onChange={handleDateOfLogChange}  label="Date of log" />
			  </DemoContainer>
			</LocalizationProvider>
		  
		  <br/>
		  
		  	<FormControl sx={{ m: 1, width: '500px',margin:'0px' }}>
				  <InputLabel id="demo-select-large-label">Day Of Week</InputLabel>
				  <Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={dayOfWeek}
					label="Day Of Week"
					onChange={(e) => handleDayOfWeekChange(e)}
					disabled
				  >
				  {daysOfWeek.map((opt,index) => (
					  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
				  ))}
				  </Select>
				</FormControl>

				<br/><br/>
				
				 <FormControl sx={{ m: 1, width: '500px',margin:'0px' }}>
				    <InputLabel id="demo-simple-select-label">Work / School day</InputLabel>
					  <Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						value={workSchoolDay}
						label="Work / School day"
						name="work_school_day"
						onChange={handleWorkSchoolDayChange}
					  >
						<MenuItem value={null}>&nbsp;&nbsp;</MenuItem>
						<MenuItem value={true}>Yes</MenuItem>
						<MenuItem value={false}>No</MenuItem>
					  </Select>
				</FormControl>
				
				
				<h3>Notes</h3>
				<Editor
				toolbar={NotesEditorToolbar}
				editorStyle={{ border: "1px solid grey" ,backgroundColor:"white",minHeight:"150px"}}
				editorState={editorState}
				toolbarClassName="toolbarClassName"
				wrapperClassName="wrapperClassName"
				editorClassName="editorClassName"
				onEditorStateChange={onEditorStateChange}
				/>

		<br/>
				
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNewClientLogModalClose}>Cancel</Button>
          <Button type="submit">Save</Button>
        </DialogActions>
		</Box>
      </Dialog>
	  
	    <Dialog
			open={openReportConfigModal}
			onClose={() => setOpenReportConfigModal(false)}
		>
        <DialogTitle>
          {reportType} Report Configuration
        </DialogTitle>
			<DialogContent dividers>	
				<Box>
					<Typography>Set Number of Food Group Contributors to Show</Typography>
					<TextField id="outlined-number" variant="outlined" type="number" InputProps={{ inputProps: { min: 0 } }} value={numberOfFoodGroups} onChange={(e) => setNumberOfFoodGroups(e.target.value)}/>

					<Typography>Set Nutrient Type for Top Food Group Contributors</Typography>
					<Select
						sx={{width: "100%"}} 
						value={nutrientTypeTopContributors}
						onChange={(e) => setNutrientTypeTopContributors(e.target.value)}
					>
						{nutrientTypes.map(opt => (
					  		<MenuItem key={opt} value={opt}>{opt}</MenuItem>
				  		))}
					</Select>

					<Typography>Set Nutrient Type to show on Pie Chart</Typography>
					<Select
						sx={{width: "100%"}} 
						value={nutrientTypePie}
						onChange={(e) => setNutrientTypePie(e.target.value)}
					>
						{nutrientTypes.map(opt => (
					  		<MenuItem key={opt} value={opt}>{opt}</MenuItem>
				  		))}
					</Select>

					<Typography>Set Nutrient Type to show on Bar Chart</Typography>
					<Select
						sx={{width: "100%"}}
						value={nutrientTypeBar}
						onChange={(e) => setNutrientTypeBar(e.target.value)}
					>
						{nutrientTypes.map(opt => (
					  		<MenuItem key={opt} value={opt}>{opt}</MenuItem>
				  		))}
					</Select>
				</Box>	
				<br></br>
				<DialogActions>
					<Button 
						disabled={nutrientTypeTopContributors===""&&numberOfFoodGroups===""&&nutrientTypePie===""&&nutrientTypeBar===""} 
						onClick={handleReportConfigModalClose} variant="contained" endIcon={<FileDownloadIcon />}>
						Generate Report
					</Button>
				</DialogActions>
			</DialogContent>
		</Dialog>

		<Dialog
			open={openDownloadModal}
		>
        <DialogTitle>
          Generating {reportType} Report
        </DialogTitle>
			<DialogContent dividers>
				{openDownloadModal&&downloadDisabled ? 		
					<Box>
						<CircularProgress />
						<Typography gutterBottom>
							Please wait, this may take a moment...
						</Typography>
					</Box>	
					:
					<Typography gutterBottom>
						A Report has been generated. Click the button below to download your PDF.
					</Typography> 	
				}
				<br></br>
				<DialogActions>
					<Button disabled={downloadDisabled} onClick={handleDownloadModalClose} variant="contained" endIcon={<FileDownloadIcon />}>
						Download Report
					</Button>
				</DialogActions>
			</DialogContent>
		</Dialog>
	
	<br /><br />
	{(clientLogData.length==0) ?
	<>
		None found
	</>
	:<>
	
	  	<div style={{ width: '100%' }}>	
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
         // bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  {(currentUser.__t=='Master') ?
		<>
		 <Button onClick={(e) => handleClientLogDailyAveragesDownload(e)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
			Daily Averages
	  </Button>&nbsp;
	
	  <Button onClick={(e) => handleClientLogDailyTotalsDownload(e)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
			Daily Totals
	  </Button>&nbsp;
	 
	  <Button onClick={(e) => handleClientLogDownload(e)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
			Client Logs
	  </Button>
		 {/* <Button onClick={(e) => handleTestDownload(e)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
			Download csv
	  </Button>&nbsp;
	  	<Button onClick={(e) => handleGenerateReport(e)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
			Generate report
	  </Button>&nbsp;*/}
		
		</>:<></>}
		</Box>
    </div>
	
	
	<TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">ID</TableCell>
            <TableCell align="left">Date created</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clientLogData.map((log) => (
            <TableRow
              key={log._id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="left"><Link href={`/client/log/${log._id}`}>{log.name}</Link></TableCell>
              <TableCell align="left">{formatDate(log.created_date)}</TableCell>
              <TableCell align="right">
			  {(log.completed) ?
				<>
				Complete &nbsp; <CircleIcon  fontSize="small"  style={{  color: 'green',fontSize:"small" }} /> 
				</>
				:<>
				Pending &nbsp; <CircleIcon    style={{  color: 'orange',fontSize:"small" }} /> </>}
			  </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
	
	
	
	</>}
	 
	<br/><br/><br/>
	
	
	{/* Admin */}
	{(currentUser.__t=='Admin') ?
	<>
	
	</>
	:<></>}
	
	{/* Master */}
	{(currentUser.__t=='Master') ?
	<>
	
	</>
	:<></>}
	
	{/* Researcher */}
	{(currentUser.__t=='Researcher') ?
	<>
	
	</>
	:<></>}

	</AppLogout>
	</>
  ) 
  ;
};

export default ClientLogs;